import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['mainField']

  connect() {
    // Bind paste event to handle pasting the full OTP code
    this.element.addEventListener('paste', this.handlePaste.bind(this))

    // Bind input and change events to handle autofill from password managers
    this.element.addEventListener('input', this.handleAutofill.bind(this))
    this.element.addEventListener('change', this.handleAutofill.bind(this))
  }

  disconnect() {
    // Clean up event listeners
    this.element.removeEventListener('paste', this.handlePaste.bind(this))
    this.element.removeEventListener('input', this.handleAutofill.bind(this))
    this.element.removeEventListener('change', this.handleAutofill.bind(this))
  }

  checkAllowance(e) {
    if (!this._isValidOtpField(e.key)) {
      e.preventDefault();
    }
  }

  handleInputEvent(e) {
    const digitValue = e.data
    if (digitValue == null) { return; }

    if(('0' <= digitValue && digitValue <= '9')) {
      const next = this.element.querySelector(`input#${e.currentTarget.dataset.next}`)

      if(next !== null) {
        next.focus()
      }
    }

    this._updateMainField()
  }

  handleKeyUp(e) {
    if(e.key === 'Backspace' || e.key === 'ArrowLeft') {
      const prev = this.element.querySelector(`input#${e.currentTarget.dataset.previous}`)

      if(prev !== null) {
        prev.focus()
      }
    } else if(e.key === 'ArrowRight') {
      const next = this.element.querySelector(`input#${e.currentTarget.dataset.next}`)

      if(next !== null) {
        next.focus()
      }
    } else if(e.key === 'Enter' && this._allFieldsAreFilled()) {
      this.mainFieldTarget.form.submit()
    }
  }

  handlePaste(e) {
    e.preventDefault()

    // Get pasted content
    const pastedData = (e.clipboardData || window.clipboardData).getData('text')

    // Clean the pasted data to only include digits
    const digits = pastedData.replace(/\D/g, '').split('')

    // Get the code length from data attribute
    const codeLength = Number(this.data.get("codeLength"))

    // Only proceed if we have the right number of digits
    if (digits.length !== codeLength) {
      return
    }

    // Fill each input field with the corresponding digit
    for (let i = 1; i <= codeLength; i++) {
      const input = this.element.querySelector(`input#digit-${i}`)
      if (input) {
        input.value = digits[i - 1]
      }
    }

    // Update the main field
    this._updateMainField()

    // Focus the last input field
    const lastInput = this.element.querySelector(`input#digit-${codeLength}`)
    if (lastInput) {
      lastInput.focus()
    }
  }

  handleAutofill(e) {
    // Check if this looks like an autofill event
    // Autofill typically fills multiple fields at once or fills a field without user interaction
    const codeLength = Number(this.data.get("codeLength"))
    let allDigits = ''

    // Collect all digit values
    for (let i = 1; i <= codeLength; i++) {
      const input = this.element.querySelector(`input#digit-${i}`)
      if (input) {
        allDigits += input.value
      }
    }

    // If we have a complete code and it's all digits, this might be autofill
    if (allDigits.length === codeLength && /^\d+$/.test(allDigits)) {
      // Update the main field
      this._updateMainField()

      // Focus the last input field
      const lastInput = this.element.querySelector(`input#digit-${codeLength}`)
      if (lastInput) {
        lastInput.focus()
      }

      // If all fields are filled, consider submitting the form
      if (this._allFieldsAreFilled()) {
        // Small delay to ensure all autofill events have completed
        setTimeout(() => {
          if (this._allFieldsAreFilled()) {
            this.mainFieldTarget.form.submit()
          }
        }, 100)
      }
    }
  }

  _updateMainField() {
    let otpCode = ''
    for (var i = 1; i < (Number(this.data.get("codeLength")) + 1); i += 1) {
      otpCode += this.element.querySelector(`input#digit-${i}`).value
    }

    this.mainFieldTarget.value = otpCode
  }

  _isValidOtpField(key) {
    return (key === 'Backspace') ||
            (key === 'ArrowLeft') ||
            (key === 'ArrowRight') ||
            ('0' <= key && key <= '9') ||
            ('a' <= key && key <= 'z');
  }

  _allFieldsAreFilled() {
    return this.mainFieldTarget.value.length === Number(this.data.get("codeLength"))
  }

}